import type {ProductCatalogItem} from '@ozon-ai/ozon/contracts';
import {Badge} from '@/components/ui/badge.tsx';
import {Card, CardContent} from '@/components/ui/card.tsx';

type ProductPickerCardProps = {
	item: ProductCatalogItem;
	stock: number | undefined;
	onSelect: () => void;
};

function formatStock(stock: number | undefined): string {
	if (stock === undefined) return '—';
	return `${stock} шт`;
}

export function ProductPickerCard({item, stock, onSelect}: ProductPickerCardProps) {
	return (
		<Card
			size="sm"
			role="button"
			tabIndex={0}
			onClick={onSelect}
			onKeyDown={(event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					onSelect();
				}
			}}
			className="cursor-pointer gap-0 py-0 shadow-sm transition-[box-shadow,ring-color] hover:shadow-md"
		>
			<div className="relative aspect-square w-full overflow-hidden bg-muted">
				{item.imageUrl ? (
					<img
						src={item.imageUrl}
						alt=""
						className="size-full object-cover"
						loading="lazy"
					/>
				) : (
					<div
						className="flex size-full items-center justify-center text-3xl text-muted-foreground"
						aria-hidden
					>
						📦
					</div>
				)}
				<Badge variant="secondary" className="absolute right-2 bottom-2 tabular-nums shadow-sm">
					FBO {formatStock(stock)}
				</Badge>
			</div>
			<CardContent className="flex flex-col gap-1 p-3">
				<p className="line-clamp-2 text-sm leading-snug font-medium">{item.name}</p>
				<p className="truncate text-xs text-muted-foreground">{item.offerId}</p>
			</CardContent>
		</Card>
	);
}
